export const color_panw = '#FA582D';
export const color_strata = '#FFCB06';
export const color_prisma = '#00C0E8';
export const color_cortex = '#00CC66';
export const color_unit42 = '#C84727';
//# sourceMappingURL=color.brands.js.map